class CollectionWestSelector {
  static SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];

  static SIZE_LABEL_MAP = {
    xxs: 'XXS',
    'extra extra small': 'XXS',
    xs: 'XS',
    'extra small': 'XS',
    'x-small': 'XS',
    s: 'S',
    small: 'S',
    petit: 'S',
    m: 'M',
    medium: 'M',
    moyen: 'M',
    l: 'L',
    large: 'L',
    grand: 'L',
    xl: 'XL',
    'extra large': 'XL',
    'x-large': 'XL',
    xxl: 'XXL',
    '2xl': 'XXL',
    'extra extra large': 'XXL',
    xxxl: 'XXXL',
    '3xl': 'XXXL',
  };

  constructor() {
    console.log('[CollectionWestSelector] Initialisation de CollectionWestSelector');
    this.init();
  }

  init() {
    console.log('[CollectionWestSelector] init() appelé');
    
    // Vérifier si on est sur la page 1
    const urlParams = new URLSearchParams(window.location.search);
    const currentPage = parseInt(urlParams.get('page')) || 1;
    
    if (currentPage !== 1) {
      console.log('[CollectionWestSelector] Page différente de 1, désactivation du composant de sélection');
      // Afficher les produits directement sans sélecteur
      const productContainer = document.getElementById('ProductContainer');
      if (productContainer) {
        productContainer.classList.remove('collection-west-hidden');
        productContainer.classList.remove('hidden');
        productContainer.style.display = '';
        productContainer.classList.add('show');
      }
      // Cacher tous les sélecteurs
      const sizeSelectors = document.querySelectorAll('[id^="collection-west-size-selector-"]');
      sizeSelectors.forEach(selector => {
        selector.style.display = 'none';
        selector.style.visibility = 'hidden';
        selector.style.opacity = '0';
        selector.style.height = '0';
        selector.style.margin = '0';
        selector.style.padding = '0';
        selector.style.overflow = 'hidden';
        selector.classList.add('hidden');
        selector.setAttribute('hidden', 'true');
      });
      return; // Ne pas initialiser le composant si on n'est pas sur la page 1
    }
    
    // Vérifier IMMÉDIATEMENT si une taille est déjà sélectionnée dans l'URL
    const selectedSize = this.getSelectedSizeFromURL();
    const productContainer = document.getElementById('ProductContainer');
    
    if (selectedSize) {
      console.log('[CollectionWestSelector] Taille trouvée dans l\'URL dès l\'init:', selectedSize);
      
      // Cacher tous les sélecteurs immédiatement si une taille est sélectionnée
      const sizeSelectors = document.querySelectorAll('[id^="collection-west-size-selector-"]');
      sizeSelectors.forEach(selector => {
        selector.style.display = 'none';
        selector.style.visibility = 'hidden';
        selector.style.opacity = '0';
        selector.style.height = '0';
        selector.style.margin = '0';
        selector.style.padding = '0';
        selector.style.overflow = 'hidden';
        selector.classList.add('hidden');
        selector.setAttribute('hidden', 'true');
      });
      console.log('[CollectionWestSelector] Sélecteurs cachés immédiatement car une taille est sélectionnée');
      
      // AFFICHER les produits immédiatement si une taille est dans l'URL
      if (productContainer) {
        productContainer.classList.remove('collection-west-hidden');
        productContainer.classList.remove('hidden');
        productContainer.style.display = '';
        productContainer.classList.add('show');
        console.log('[CollectionWestSelector] Produits affichés immédiatement car taille dans URL');
      }
    } else {
      // Si aucune taille, cacher les produits
      if (productContainer) {
        productContainer.classList.add('collection-west-hidden');
        productContainer.classList.remove('show');
        productContainer.style.display = 'none';
        console.log('[CollectionWestSelector] Produits cachés car aucune taille sélectionnée');
      }
    }
    
    // Trouver tous les sélecteurs de taille West sur la page
    const sizeSelectors = document.querySelectorAll('[id^="collection-west-size-selector-"]');
    console.log('[CollectionWestSelector] Sélecteurs trouvés:', sizeSelectors.length);
    
    sizeSelectors.forEach(selector => {
      const sectionId = selector.id.replace('collection-west-size-selector-', '');
      console.log('[CollectionWestSelector] Initialisation du sélecteur pour sectionId:', sectionId);
      this.initSelector(sectionId);
    });
  }

  initSelector(sectionId) {
    console.log('[CollectionWestSelector] initSelector() appelé pour sectionId:', sectionId);
    
    const productContainer = document.getElementById('ProductContainer');
    const dataElement = document.getElementById(`collection-west-data-${sectionId}`);
    
    // Vérifier IMMÉDIATEMENT si une taille est déjà sélectionnée dans l'URL
    const selectedSize = this.getSelectedSizeFromURL();
    
    if (selectedSize) {
      // Si une taille est dans l'URL, cacher le sélecteur et AFFICHER les produits immédiatement
      console.log('[CollectionWestSelector] Taille trouvée dans l\'URL:', selectedSize);
      this.hideSelector(sectionId);
      
      if (productContainer) {
        productContainer.classList.remove('collection-west-hidden');
        productContainer.classList.remove('hidden');
        productContainer.style.display = '';
        productContainer.classList.add('show');
        console.log('[CollectionWestSelector] Produits affichés immédiatement car taille dans URL');
      }
    } else {
      // Si aucune taille, cacher les produits et afficher le sélecteur
      if (productContainer) {
        productContainer.classList.add('collection-west-hidden');
        productContainer.classList.remove('show');
        productContainer.style.display = 'none';
        console.log('[CollectionWestSelector] Produits cachés car aucune taille sélectionnée');
      }
      this.showSelector(sectionId);
    }
    
    if (!dataElement) {
      console.warn('[CollectionWestSelector] Élément de données non trouvé:', `collection-west-data-${sectionId}`);
      return;
    }

    const data = JSON.parse(dataElement.textContent);
    console.log('[CollectionWestSelector] Données parsées:', data);
    const sizesGrid = document.getElementById(`sizes-grid-${sectionId}`);
    
    if (!sizesGrid) {
      console.warn('[CollectionWestSelector] Grille de tailles non trouvée:', `sizes-grid-${sectionId}`);
    }
    if (!productContainer) {
      console.warn('[CollectionWestSelector] Conteneur de produits non trouvé: ProductContainer');
    }
    if (!sizesGrid || !productContainer) return;

    const sizes = data.sizes || [];
    this.renderSizeCircles(sizesGrid, sizes, sectionId);
    
    if (selectedSize) {
      const circle = this.findSizeCircle(sizesGrid, selectedSize);
      if (circle) {
        circle.classList.add('active');
        console.log('[CollectionWestSelector] Cercle marqué comme actif:', selectedSize);
      }
      
      // Attendre un peu pour que les filtres soient chargés, puis appliquer le filtre
      setTimeout(() => {
        this.applySizeFilter(selectedSize);
        // S'assurer que le sélecteur est bien caché
        this.hideSelector(sectionId);
        // S'assurer que les produits sont bien affichés
        if (productContainer) {
          productContainer.classList.remove('collection-west-hidden');
          productContainer.classList.remove('hidden');
          productContainer.style.display = '';
          productContainer.classList.add('show');
        }
      }, 300);
    }
  }

  normalizeSizeLabel(raw) {
    return CollectionWestSelector.normalizeSizeLabel(raw);
  }

  static normalizeSizeLabel(raw) {
    if (!raw) return '';
    const text = raw.toString().trim();

    // Extraire l'abréviation entre parenthèses : "TAILLE MOYENNE (M)" → "M"
    const parenMatch = text.match(/\(([^)]+)\)/);
    if (parenMatch) {
      const inner = parenMatch[1].trim();
      const innerKey = inner.toLowerCase();
      if (CollectionWestSelector.SIZE_LABEL_MAP[innerKey]) {
        return CollectionWestSelector.SIZE_LABEL_MAP[innerKey];
      }
      const innerUpper = inner.toUpperCase();
      if (CollectionWestSelector.SIZE_ORDER.includes(innerUpper)) {
        return innerUpper;
      }
      return innerUpper;
    }

    const key = text.toLowerCase();
    if (CollectionWestSelector.SIZE_LABEL_MAP[key]) {
      return CollectionWestSelector.SIZE_LABEL_MAP[key];
    }

    const frenchPatterns = [
      [/très\s*petite\s*taille/i, 'XS'],
      [/tres\s*petite\s*taille/i, 'XS'],
      [/petite\s*taille/i, 'S'],
      [/taille\s*moyenne/i, 'M'],
      [/taille\s*large/i, 'L'],
      [/extra\s*large/i, 'XL'],
      [/double\s*xl/i, 'XXL'],
    ];
    for (const [pattern, size] of frenchPatterns) {
      if (pattern.test(text)) return size;
    }

    const compact = text.replace(/\s+/g, '').toUpperCase();
    if (CollectionWestSelector.SIZE_ORDER.includes(compact)) return compact;

    return text.toUpperCase();
  }

  getSizeSortIndex(size) {
    return CollectionWestSelector.getSizeSortIndex(size);
  }

  static getSizeSortIndex(size) {
    const normalized = CollectionWestSelector.normalizeSizeLabel(size);
    const index = CollectionWestSelector.SIZE_ORDER.indexOf(normalized);
    return index === -1 ? CollectionWestSelector.SIZE_ORDER.length : index;
  }

  sizesMatch(sizeA, sizeB) {
    return CollectionWestSelector.sizesMatch(sizeA, sizeB);
  }

  static sizesMatch(sizeA, sizeB) {
    if (!sizeA || !sizeB) return false;
    const a = sizeA.toString().trim().toLowerCase();
    const b = sizeB.toString().trim().toLowerCase();
    if (a === b) return true;
    if (a.replace(/\s+/g, '') === b.replace(/\s+/g, '')) return true;
    return CollectionWestSelector.normalizeSizeLabel(a) === CollectionWestSelector.normalizeSizeLabel(b);
  }

  findSizeCircle(container, size) {
    const circles = container.querySelectorAll('.collection-west-size-circle');
    for (const circle of circles) {
      const filterValue = circle.getAttribute('data-size');
      const displayLabel = circle.getAttribute('data-display-size');
      if (this.sizesMatch(filterValue, size) || this.sizesMatch(displayLabel, size)) {
        return circle;
      }
    }
    return null;
  }

  renderSizeCircles(container, sizes, sectionId) {
    container.innerHTML = '';

    const sortedSizes = [...sizes].sort((a, b) => {
      const labelA = a.label || a.value;
      const labelB = b.label || b.value;
      return this.getSizeSortIndex(labelA) - this.getSizeSortIndex(labelB);
    });

    sortedSizes.forEach((sizeData) => {
      const count = sizeData.count;
      if (count > 0) {
        const filterValue = sizeData.value || sizeData.label;
        const displayLabel = this.normalizeSizeLabel(sizeData.label || sizeData.value);
        const circle = this.createSizeCircle(filterValue, displayLabel, count, sectionId);
        container.appendChild(circle);
      }
    });
  }

  createSizeCircle(filterValue, displayLabel, count, sectionId) {
    const circle = document.createElement('div');
    circle.className = 'collection-west-size-circle';
    circle.setAttribute('data-size', filterValue);
    circle.setAttribute('data-display-size', displayLabel);
    circle.setAttribute('data-section-id', sectionId);
    
    const label = document.createElement('div');
    label.className = 'collection-west-size-label';
    label.textContent = displayLabel;
    
    circle.appendChild(label);
    
    circle.addEventListener('click', () => {
      console.log('[CollectionWestSelector] Cercle cliqué:', { filterValue, displayLabel, sectionId });
      if (!circle.classList.contains('disabled')) {
        console.log('[CollectionWestSelector] Cercle non désactivé, appel de selectSize...');
        this.selectSize(filterValue, sectionId);
      } else {
        console.log('[CollectionWestSelector] Cercle désactivé, clic ignoré');
      }
    });
    
    return circle;
  }

  getSelectedSizeFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    // Chercher dans les filtres de taille - priorité à filter.v.t.shopify.size
    for (const [key, value] of urlParams.entries()) {
      if (key.includes('filter.v.t.shopify.size')) {
        return decodeURIComponent(value);
      }
    }
    // Fallback : autres filtres de taille
    for (const [key, value] of urlParams.entries()) {
      if (key.includes('filter.v.option') || key.includes('filter.p.m.custom.size')) {
        return decodeURIComponent(value);
      }
    }
    return null;
  }

  hideSelector(sectionId) {
    // Cacher tous les sélecteurs de taille - méthode robuste
    const selectorId = `collection-west-size-selector-${sectionId}`;
    const selectorElement = document.getElementById(selectorId);
    
    // Méthode 1: Par ID
    if (selectorElement) {
      selectorElement.style.display = 'none';
      selectorElement.style.visibility = 'hidden';
      selectorElement.style.opacity = '0';
      selectorElement.style.height = '0';
      selectorElement.style.margin = '0';
      selectorElement.style.padding = '0';
      selectorElement.style.overflow = 'hidden';
      selectorElement.classList.add('hidden');
      selectorElement.setAttribute('hidden', 'true');
      console.log('[CollectionWestSelector] ✓ Sélecteur caché par ID:', selectorId);
    } else {
      console.warn('[CollectionWestSelector] ✗ Sélecteur non trouvé par ID:', selectorId);
    }
    
    // Méthode 2: Par classe et ID partiel
    const selectorsByClass = document.querySelectorAll('.collection-west-size-selector');
    selectorsByClass.forEach(selector => {
      if (selector.id === selectorId || selector.id.includes(sectionId)) {
        selector.style.display = 'none';
        selector.style.visibility = 'hidden';
        selector.style.opacity = '0';
        selector.style.height = '0';
        selector.style.margin = '0';
        selector.style.padding = '0';
        selector.style.overflow = 'hidden';
        selector.classList.add('hidden');
        selector.setAttribute('hidden', 'true');
        console.log('[CollectionWestSelector] ✓ Sélecteur caché par classe:', selector.id);
      }
    });
    
    // Méthode 3: Tous les sélecteurs qui commencent par collection-west-size-selector
    const allSelectors = document.querySelectorAll('[id^="collection-west-size-selector-"]');
    allSelectors.forEach(selector => {
      if (selector.id === selectorId || selector.id.includes(sectionId)) {
        selector.style.display = 'none';
        selector.style.visibility = 'hidden';
        selector.style.opacity = '0';
        selector.style.height = '0';
        selector.style.margin = '0';
        selector.style.padding = '0';
        selector.style.overflow = 'hidden';
        selector.classList.add('hidden');
        selector.setAttribute('hidden', 'true');
        console.log('[CollectionWestSelector] ✓ Sélecteur caché par attribut:', selector.id);
      }
    });
  }

  showSelector(sectionId) {
    // Afficher le sélecteur de taille pour cette section
    const selectorId = `collection-west-size-selector-${sectionId}`;
    const selectorElement = document.getElementById(selectorId);
    
    if (selectorElement) {
      selectorElement.style.display = '';
      selectorElement.style.visibility = '';
      selectorElement.style.opacity = '';
      selectorElement.style.height = '';
      selectorElement.style.margin = '';
      selectorElement.style.padding = '';
      selectorElement.style.overflow = '';
      selectorElement.classList.remove('hidden');
      selectorElement.removeAttribute('hidden');
      console.log('[CollectionWestSelector] ✓ Sélecteur affiché:', selectorId);
    }
    
    // Aussi chercher par classe au cas où
    const selectorsByClass = document.querySelectorAll('.collection-west-size-selector');
    selectorsByClass.forEach(selector => {
      if (selector.id === selectorId || selector.id.includes(sectionId)) {
        selector.style.display = '';
        selector.style.visibility = '';
        selector.style.opacity = '';
        selector.style.height = '';
        selector.style.margin = '';
        selector.style.padding = '';
        selector.style.overflow = '';
        selector.classList.remove('hidden');
        selector.removeAttribute('hidden');
      }
    });
  }

  selectSize(size, sectionId) {
    console.log('[CollectionWestSelector] selectSize() appelé avec:', { size, sectionId });
    
    // CACHER LE SÉLECTEUR IMMÉDIATEMENT pour éviter le blink
    this.hideSelector(sectionId);
    
    // Mettre à jour l'état visuel des cercles
    const circles = document.querySelectorAll(`[data-section-id="${sectionId}"].collection-west-size-circle`);
    console.log('[CollectionWestSelector] Cercles trouvés:', circles.length);
    circles.forEach(circle => {
      const filterValue = circle.getAttribute('data-size');
      if (this.sizesMatch(filterValue, size)) {
        circle.classList.add('active');
        console.log('[CollectionWestSelector] Cercle activé:', filterValue);
      } else {
        circle.classList.remove('active');
      }
    });
    
    // Trouver le filtre de taille dans les filtres de gauche
    console.log('[CollectionWestSelector] Appel de applySizeFilter pour la taille:', size);
    this.applySizeFilter(size);
    
    // Afficher les produits après un délai pour laisser le temps au filtre de s'appliquer
    // Mais seulement si une taille est vraiment sélectionnée
    setTimeout(() => {
      const productContainer = document.getElementById('ProductContainer');
      if (productContainer) {
        productContainer.classList.remove('collection-west-hidden');
        productContainer.classList.remove('hidden');
        productContainer.style.display = '';
        productContainer.classList.add('show');
        console.log('[CollectionWestSelector] Conteneur de produits affiché');
      }
      
      // Vérifier à nouveau que le sélecteur est bien caché
      this.hideSelector(sectionId);
    }, 300);
  }

  applySizeFilter(size) {
    console.log('[CollectionWestSelector] applySizeFilter() appelé avec la taille:', size);
    
    // Trouver le formulaire de filtres
    const filterForm = document.getElementById('FacetFiltersForm');
    const filterFormMobile = document.getElementById('FacetFiltersFormMobile');
    
    console.log('[CollectionWestSelector] Formulaires trouvés:', {
      desktop: !!filterForm,
      mobile: !!filterFormMobile
    });
    
    let sizeInputFound = false;
    
    // Chercher dans le formulaire desktop
    if (filterForm) {
      console.log('[CollectionWestSelector] Recherche dans le formulaire desktop...');
      const sizeInput = this.findSizeInput(filterForm, size);
      if (sizeInput) {
        console.log('[CollectionWestSelector] ✓ Checkbox trouvée dans le formulaire desktop:', {
          name: sizeInput.name,
          value: sizeInput.value,
          checked: sizeInput.checked,
          id: sizeInput.id
        });
        
        if (!sizeInput.checked) {
          sizeInput.checked = true;
          console.log('[CollectionWestSelector] Checkbox cochée');
          sizeInputFound = true;
        } else {
          console.log('[CollectionWestSelector] Checkbox déjà cochée');
        }
        
        // Déclencher les événements nécessaires pour que FacetFiltersForm le détecte
        setTimeout(() => {
          console.log('[CollectionWestSelector] Déclenchement des événements...');
          
          // Déclencher l'événement change sur la checkbox
          const changeEvent = new Event('change', { bubbles: true, cancelable: true });
          sizeInput.dispatchEvent(changeEvent);
          console.log('[CollectionWestSelector] Événement change déclenché');
          
          // Déclencher l'événement input sur la checkbox (c'est ce que FacetFiltersForm écoute)
          const inputEvent = new Event('input', { bubbles: true, cancelable: true });
          sizeInput.dispatchEvent(inputEvent);
          console.log('[CollectionWestSelector] Événement input déclenché sur la checkbox');
          
          // Déclencher aussi sur le formulaire pour être sûr
          const formInputEvent = new Event('input', { bubbles: true, cancelable: true });
          filterForm.dispatchEvent(formInputEvent);
          console.log('[CollectionWestSelector] Événement input déclenché sur le formulaire');
        }, 100);
      } else {
        console.warn('[CollectionWestSelector] ✗ Aucune checkbox trouvée pour la taille:', size, 'dans le formulaire desktop');
      }
    } else {
      console.warn('[CollectionWestSelector] Formulaire desktop non trouvé: FacetFiltersForm');
    }
    
    // Chercher dans le formulaire mobile
    if (filterFormMobile) {
      console.log('[CollectionWestSelector] Recherche dans le formulaire mobile...');
      const sizeInputMobile = this.findSizeInput(filterFormMobile, size);
      if (sizeInputMobile) {
        console.log('[CollectionWestSelector] ✓ Checkbox trouvée dans le formulaire mobile:', {
          name: sizeInputMobile.name,
          value: sizeInputMobile.value,
          checked: sizeInputMobile.checked,
          id: sizeInputMobile.id
        });
        
        if (!sizeInputMobile.checked) {
          sizeInputMobile.checked = true;
          console.log('[CollectionWestSelector] Checkbox mobile cochée');
        }
        
        if (!sizeInputFound) {
          setTimeout(() => {
            console.log('[CollectionWestSelector] Déclenchement des événements sur mobile...');
            
            // Déclencher l'événement change sur la checkbox
            const changeEvent = new Event('change', { bubbles: true, cancelable: true });
            sizeInputMobile.dispatchEvent(changeEvent);
            console.log('[CollectionWestSelector] Événement change déclenché (mobile)');
            
            // Déclencher l'événement input sur la checkbox
            const inputEvent = new Event('input', { bubbles: true, cancelable: true });
            sizeInputMobile.dispatchEvent(inputEvent);
            console.log('[CollectionWestSelector] Événement input déclenché sur la checkbox (mobile)');
            
            // Déclencher aussi sur le formulaire
            const formInputEvent = new Event('input', { bubbles: true, cancelable: true });
            filterFormMobile.dispatchEvent(formInputEvent);
            console.log('[CollectionWestSelector] Événement input déclenché sur le formulaire (mobile)');
          }, 100);
        }
      } else {
        console.warn('[CollectionWestSelector] ✗ Aucune checkbox trouvée pour la taille:', size, 'dans le formulaire mobile');
      }
    } else {
      console.warn('[CollectionWestSelector] Formulaire mobile non trouvé: FacetFiltersFormMobile');
    }
  }

  findSizeInput(form, size) {
    console.log('[CollectionWestSelector] findSizeInput() appelé avec:', { form: form.id || 'form', size });
    
    // Fonction helper pour normaliser une taille (enlever espaces, convertir en minuscule)
    const normalizeSizeValue = (value) => {
      if (!value) return '';
      return value.toString().trim().toLowerCase();
    };
    
    // Fonction helper pour extraire la taille du label
    const extractSizeFromLabel = (labelText) => {
      if (!labelText) return '';
      // Enlever les éléments visuellement cachés et les compteurs
      const cleanText = labelText
        .replace(/\([^)]*\)/g, '') // Enlever les parenthèses et leur contenu
        .replace(/\d+/g, '') // Enlever les chiffres (compteurs)
        .trim();
      
      // Chercher la taille au début du texte nettoyé
      const match = cleanText.match(/^([A-Za-z0-9]+(?:\s*[A-Za-z0-9]+)*)/);
      return match ? match[1].trim().toLowerCase() : cleanText.trim().toLowerCase();
    };
    
    // Chercher toutes les cases à cocher dans le formulaire
    const checkboxes = form.querySelectorAll('input[type="checkbox"]');
    const normalizedSize = size.trim().toLowerCase();
    
    console.log('[CollectionWestSelector] Nombre de checkboxes trouvées:', checkboxes.length);
    console.log('[CollectionWestSelector] Taille recherchée (normalisée):', normalizedSize);
    
    // Lister toutes les checkboxes pour debug
    const sizeFilters = [];
    const availableSizes = [];
    
    checkboxes.forEach((checkbox, index) => {
      const paramName = checkbox.name || '';
      if (paramName.includes('filter.v.t.shopify.size') || 
          paramName.includes('filter.v.option') || 
          paramName.includes('filter.p.m.custom.size')) {
        const checkboxValue = normalizeSizeValue(checkbox.value);
        const label = checkbox.closest('label');
        let labelText = '';
        let labelSize = '';
        
        if (label) {
          labelText = label.textContent.trim();
          labelSize = extractSizeFromLabel(labelText);
        }
        
        const sizeInfo = {
          index,
          name: paramName,
          value: checkbox.value,
          normalizedValue: checkboxValue,
          id: checkbox.id,
          checked: checkbox.checked,
          labelText: labelText,
          labelSize: labelSize
        };
        
        sizeFilters.push(sizeInfo);
        
        // Ajouter à la liste des tailles disponibles
        const sizeDisplay = labelSize || checkboxValue || checkbox.value || 'N/A';
        if (!availableSizes.includes(sizeDisplay)) {
          availableSizes.push(sizeDisplay);
        }
      }
    });
    
    console.log('[CollectionWestSelector] ===== TAILLES DE FILTRE DISPONIBLES =====');
    console.log('[CollectionWestSelector] Nombre total de filtres de taille:', sizeFilters.length);
    console.log('[CollectionWestSelector] Tailles disponibles:', availableSizes.sort());
    console.log('[CollectionWestSelector] Détails des checkboxes de taille:', sizeFilters);
    console.log('[CollectionWestSelector] Taille recherchée:', normalizedSize);
    console.log('[CollectionWestSelector] =========================================');
    
    // Fonction helper pour vérifier si deux tailles correspondent
    const sizesMatch = (size1, size2) => {
      if (!size1 || !size2) return false;
      const s1 = normalizeSizeValue(size1);
      const s2 = normalizeSizeValue(size2);
      
      // Correspondance exacte
      if (s1 === s2) return true;
      
      // Correspondance avec espaces ignorés (ex: "X L" vs "XL")
      const s1NoSpaces = s1.replace(/\s+/g, '');
      const s2NoSpaces = s2.replace(/\s+/g, '');
      if (s1NoSpaces === s2NoSpaces) return true;
      
      return false;
    };
    
    // ÉTAPE 1: Chercher d'abord les correspondances EXACTES avec filter.v.t.shopify.size
    for (const checkbox of checkboxes) {
      const paramName = checkbox.name || '';
      if (paramName.includes('filter.v.t.shopify.size')) {
        const checkboxValue = normalizeSizeValue(checkbox.value);
        
        // Correspondance exacte par valeur
        if (sizesMatch(checkboxValue, normalizedSize)) {
          console.log('[CollectionWestSelector] ✓ Match trouvé par valeur (filter.v.t.shopify.size):', {
            recherché: normalizedSize,
            trouvé: checkboxValue,
            name: paramName
          });
          return checkbox;
        }
        
        // Correspondance par label
        const label = checkbox.closest('label');
        if (label) {
          const labelText = label.textContent.trim();
          const labelSize = extractSizeFromLabel(labelText);
          
          if (sizesMatch(labelSize, normalizedSize)) {
            console.log('[CollectionWestSelector] ✓ Match trouvé par label (filter.v.t.shopify.size):', {
              recherché: normalizedSize,
              trouvé: labelSize,
              labelText: labelText
            });
            return checkbox;
          }
          
          // Vérification supplémentaire : chercher directement dans le texte du label
          const labelTextLower = labelText.toLowerCase();
          const normalizedSizeLower = normalizedSize.toLowerCase();
          if (labelTextLower.includes(normalizedSizeLower) && 
              (labelTextLower.startsWith(normalizedSizeLower) || 
               labelTextLower.match(new RegExp(`\\b${normalizedSizeLower}\\b`)))) {
            console.log('[CollectionWestSelector] ✓ Match trouvé par recherche dans label (filter.v.t.shopify.size):', {
              recherché: normalizedSize,
              labelText: labelText
            });
            return checkbox;
          }
        }
      }
    }
    
    // ÉTAPE 2: Si pas trouvé, chercher dans les autres filtres de taille
    for (const checkbox of checkboxes) {
      const paramName = checkbox.name || '';
      const isSizeFilter = paramName.includes('filter.v.option') || 
                          paramName.includes('filter.p.m.custom.size');
      
      if (isSizeFilter && !paramName.includes('filter.v.t.shopify.size')) {
        const checkboxValue = normalizeSizeValue(checkbox.value);
        
        // Correspondance exacte par valeur
        if (sizesMatch(checkboxValue, normalizedSize)) {
          console.log('[CollectionWestSelector] ✓ Match trouvé par valeur (fallback):', {
            recherché: normalizedSize,
            trouvé: checkboxValue,
            name: paramName
          });
          return checkbox;
        }
        
        // Correspondance par label
        const label = checkbox.closest('label');
        if (label) {
          const labelText = label.textContent.trim();
          const labelSize = extractSizeFromLabel(labelText);
          
          if (sizesMatch(labelSize, normalizedSize)) {
            console.log('[CollectionWestSelector] ✓ Match trouvé par label (fallback):', {
              recherché: normalizedSize,
              trouvé: labelSize,
              labelText: labelText
            });
            return checkbox;
          }
          
          // Vérification supplémentaire : chercher directement dans le texte du label
          const labelTextLower = labelText.toLowerCase();
          const normalizedSizeLower = normalizedSize.toLowerCase();
          if (labelTextLower.includes(normalizedSizeLower) && 
              (labelTextLower.startsWith(normalizedSizeLower) || 
               labelTextLower.match(new RegExp(`\\b${normalizedSizeLower}\\b`)))) {
            console.log('[CollectionWestSelector] ✓ Match trouvé par recherche dans label (fallback):', {
              recherché: normalizedSize,
              labelText: labelText
            });
            return checkbox;
          }
        }
      }
    }
    
    console.warn('[CollectionWestSelector] ✗ Aucune checkbox correspondante trouvée pour la taille:', size);
    console.warn('[CollectionWestSelector] Taille recherchée:', normalizedSize);
    console.warn('[CollectionWestSelector] Checkboxes disponibles:', sizeFilters.map(f => ({ value: f.value, name: f.name })));
    return null;
  }
}

// Initialiser quand le DOM est prêt
console.log('[CollectionWestSelector] État du document:', document.readyState);
if (document.readyState === 'loading') {
  console.log('[CollectionWestSelector] Attente du DOMContentLoaded...');
  document.addEventListener('DOMContentLoaded', () => {
    console.log('[CollectionWestSelector] DOMContentLoaded déclenché, initialisation...');
    new CollectionWestSelector();
  });
} else {
  console.log('[CollectionWestSelector] DOM déjà prêt, initialisation immédiate...');
  new CollectionWestSelector();
}

// Réinitialiser après les changements de filtres AJAX
document.addEventListener('facet:updated', () => {
  console.log('[CollectionWestSelector] Événement facet:updated détecté, réinitialisation...');
  setTimeout(() => {
    new CollectionWestSelector();
  }, 100);
});

// Fonction helper pour obtenir la taille sélectionnée depuis l'URL
function getSelectedSizeFromURL() {
  const urlParams = new URLSearchParams(window.location.search);
  // Chercher dans les filtres de taille - priorité à filter.v.t.shopify.size
  for (const [key, value] of urlParams.entries()) {
    if (key.includes('filter.v.t.shopify.size')) {
      return decodeURIComponent(value);
    }
  }
  // Fallback : autres filtres de taille
  for (const [key, value] of urlParams.entries()) {
    if (key.includes('filter.v.option') || key.includes('filter.p.m.custom.size')) {
      return decodeURIComponent(value);
    }
  }
  return null;
}

// Fonction helper pour cacher/afficher les sélecteurs (utilisable sans instance)
function hideAllSizeSelectors() {
  const allSelectors = document.querySelectorAll('[id^="collection-west-size-selector-"]');
  console.log('[CollectionWestSelector] Cachage de tous les sélecteurs trouvés:', allSelectors.length);
  allSelectors.forEach(selector => {
    selector.style.display = 'none';
    selector.style.visibility = 'hidden';
    selector.style.opacity = '0';
    selector.style.height = '0';
    selector.style.margin = '0';
    selector.style.padding = '0';
    selector.style.overflow = 'hidden';
    selector.classList.add('hidden');
    selector.setAttribute('hidden', 'true');
    console.log('[CollectionWestSelector] ✓ Sélecteur caché:', selector.id);
  });
}

function showAllSizeSelectors() {
  const allSelectors = document.querySelectorAll('[id^="collection-west-size-selector-"]');
  console.log('[CollectionWestSelector] Affichage de tous les sélecteurs trouvés:', allSelectors.length);
  allSelectors.forEach(selector => {
    selector.style.display = '';
    selector.style.visibility = '';
    selector.style.opacity = '';
    selector.style.height = '';
    selector.style.margin = '';
    selector.style.padding = '';
    selector.style.overflow = '';
    selector.classList.remove('hidden');
    selector.removeAttribute('hidden');
    console.log('[CollectionWestSelector] ✓ Sélecteur affiché:', selector.id);
  });
}

// Écouter les changements de filtres pour mettre à jour l'état des cercles
document.addEventListener('facet:updated', () => {
  console.log('[CollectionWestSelector] Événement facet:updated détecté dans l\'écouteur');
  const selectedSize = getSelectedSizeFromURL();
  const sizeSelectors = document.querySelectorAll('[id^="collection-west-size-selector-"]');
  
  console.log('[CollectionWestSelector] Taille sélectionnée depuis URL:', selectedSize);
  console.log('[CollectionWestSelector] Sélecteurs trouvés:', sizeSelectors.length);
  
  if (selectedSize) {
    // Cacher complètement tous les sélecteurs si une taille est sélectionnée
    hideAllSizeSelectors();
    
    // Mettre à jour l'état des cercles pour chaque section
    sizeSelectors.forEach(selector => {
      const sectionId = selector.id.replace('collection-west-size-selector-', '');
      const circles = document.querySelectorAll(`[data-section-id="${sectionId}"].collection-west-size-circle`);
      circles.forEach(circle => {
        const filterValue = circle.getAttribute('data-size');
        if (CollectionWestSelector.sizesMatch(filterValue, selectedSize)) {
          circle.classList.add('active');
        } else {
          circle.classList.remove('active');
        }
      });
    });
  } else {
    // Afficher tous les sélecteurs si aucune taille n'est sélectionnée
    showAllSizeSelectors();
    
    // Retirer l'état actif de tous les cercles
    sizeSelectors.forEach(selector => {
      const sectionId = selector.id.replace('collection-west-size-selector-', '');
      const circles = document.querySelectorAll(`[data-section-id="${sectionId}"].collection-west-size-circle`);
      circles.forEach(circle => {
        circle.classList.remove('active');
      });
    });
  }
});
